import { render, staticRenderFns } from "./tagEdit.vue?vue&type=template&id=a8aa1dcc&scoped=true&"
import script from "./tagEdit.vue?vue&type=script&lang=js&"
export * from "./tagEdit.vue?vue&type=script&lang=js&"
import style0 from "./tagEdit.vue?vue&type=style&index=0&id=a8aa1dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa1dcc",
  null
  
)

export default component.exports